module.exports = __webpack_public_path__ + "img/logo-footer-new.26743d55.png";